import { Box, Loader } from '@mantine/core';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { useStartRemoteDocsConnectionOAuthMutation } from 'src/secret-menu/sharepoint/hooks/useStartRemoteDocsConnectionOAuthMutation';
import { Button } from 'src/components';
import { OAuthPlatform } from 'src/secret-menu/sharepoint/types';
import { useRemoteDocsConnections } from 'src/secret-menu/sharepoint/hooks/useRemoteDocsConnections';
import SharepointDocs from 'src/secret-menu/sharepoint/SharepointDocs';

export default function SharepointTab() {
  const {
    latestActiveConnection,
    isLoading: isLoadingConnections,
    isError,
  } = useRemoteDocsConnections();
  const { startOAuth, isLoading: isStarting } = useStartRemoteDocsConnectionOAuthMutation();

  const handleStartAuth = async (platform: OAuthPlatform) => {
    try {
      const { url } = await startOAuth(platform);
      window.location.href = url;
    } catch (error) {
      notifyAndLogError('Failed to connect calendar', 'Please try again later.', error);
    }
  };

  if (isLoadingConnections) {
    return <Loader />;
  }

  if (isError) {
    return <div>Error loading connections</div>;
  }

  if (latestActiveConnection) {
    return (
      <Box>
        <div>Connected to Sharepoint</div>
        <SharepointDocs />
      </Box>
    );
  }

  return (
    <Box>
      <Button onClick={async () => await handleStartAuth('MICROSOFT')} loading={isStarting}>
        Connect to sharepoint
      </Button>
    </Box>
  );
}
